// extracted by mini-css-extract-plugin
module.exports = {"label":"BillingPeriodTabs_label__4MbG7","tabsRow":"BillingPeriodTabs_tabsRow__kaVau","borderHidden":"BillingPeriodTabs_borderHidden__iwnEZ"};